import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AvatarComponent } from '@/design-system/atoms/avatar/avatar.component';
import { IconButtonComponent } from '@/design-system/molecules/icon-button/icon-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-user-card',
  imports: [AvatarComponent, IconButtonComponent, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './user-card.component.scss',
  templateUrl: './user-card.component.html',
})
export class UserCardComponent {
  name = input.required<string>();
  role = input.required<string>();
  settingsClick = output();
}
